import isObject from 'lodash/isObject';

const toCamel = (str: string) => str.replace(/_([a-zA-Z0-9])/g, (m) => m[1].toUpperCase());

export const transformFieldsToCamelCase = (o: unknown): unknown => {
  if (Array.isArray(o)) {
    return o.map((i) => {
      return transformFieldsToCamelCase(i);
    });
  }

  if (isObject(o)) {
    const n: Record<string, unknown> = {};

    Object.entries(o).forEach(([key, value]) => {
      n[toCamel(key)] = transformFieldsToCamelCase(value);
    });

    return n;
  }

  return o;
};

export const delay: (ms: number) => Promise<void> = (ms) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
